import { render, staticRenderFns } from "./RestoreConfirmDialog.vue?vue&type=template&id=7ec2f732&"
import script from "./RestoreConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./RestoreConfirmDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports